/* global $ */

import bog from 'bog';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import DetectElementResize from 'detect-element-resize';

import $ from '../../chart/jquery';

import '../../static/chart/chart-bundle.min';
import withErrorHandler from '../../utils/withErrorHandler';
import ChartContainer from '../../components/ChartContainer';
import { initDepthChart } from '../../utils/chart';

const DEPTH_VIEW_NAME = 'depth';
const DEFAULT_DEPTH_THEME = 'depth-white';

const mapStateToProps = ({ books, openOrders }, { symbol }) =>
  ({ book: books[symbol], openOrders });

const Container = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

export default
@withTheme
@withErrorHandler
@connect(mapStateToProps)
class DepthChartRenderer extends Component {
  static propTypes = {
    theme: PropTypes.object,
    book: PropTypes.object,
    hidden: PropTypes.bool.isRequired,
    selectedView: PropTypes.string,
    fullScreen: PropTypes.bool,
    interval: PropTypes.number,
    openOrders: PropTypes.array,
    symbol: PropTypes.string.isRequired,
  };

  static defaultProps = {
    theme: {},
    book: {},
    selectedView: 'default',
    fullScreen: false,
    interval: 60,
    openOrders: [],
  }

  componentDidMount() {
    DetectElementResize.addResizeListener(
      this._depthChartContainer.current, this._resizeHandler = () => {
        this._depth && this._depth.resize();
      });
  }

  shouldComponentUpdate({ selectedView, book, symbol, interval, theme }) {
    if (book !== this.props.book) {
      return true;
    }
    const depthIsNow = this.props.selectedView === DEPTH_VIEW_NAME;
    const depthIsNext = selectedView === DEPTH_VIEW_NAME;
    // depth is next or we are leaving depth (so hide it)
    return depthIsNext ||
      (depthIsNow && !depthIsNext) ||
      // symbol or interval changed, update chart even if hidden
      (!!this._depth && symbol !== this.props.symbol) ||
      (!!this._depth && interval !== this.props.interval) ||
      (!!this._depth && theme !== this.props.theme);
  }

  componentDidUpdate({ theme: prevTheme, openOrders: prevOpenOrders }) {
    const { book, selectedView, theme, openOrders } = this.props;

    if (this._depth) {
      if (theme !== prevTheme) {
        const el = this._depth.internals().element;
        $(el).fadeOut(0, () => {
          this._depth.onTheme(theme.depthTheme);
          $(el).fadeIn(100);
        });
      }

      if (openOrders !== prevOpenOrders) {
        this._userOrdersOndepth(openOrders);
      }
    }

    if (selectedView === DEPTH_VIEW_NAME) this._init();

    // update the "depth" chart
    if (book.asks || book.bids) {
      let newAsks = this._parsedAsks;
      let newBids = this._parsedBids;
      if (!newAsks || this._lastAsks !== book.asks) {
        newAsks = this._parsedAsks = Object.keys(book.asks||{}).reduce((obj, price) => {
          const [, , qty] = book.asks[price];
          obj[price] = qty;
          return obj;
        }, {});
      }
      if (!newBids || this._lastBids !== book.bids) {
        newBids = this._parsedBids = Object.keys(book.bids||{}).reduce((obj, price) => {
          const [, , qty] = book.bids[price];
          obj[price] = qty;
          return obj;
        }, {});
      }
      this._lastAsks = book.asks;
      this._lastBids = book.bids;
      window.OBD.loadBook(newAsks, newBids, 100);
    }else{
      window.OBD.loadBook([], [], 100);
    }
  }

  componentWillUnmount() {
    this._resizeHandler &&
    DetectElementResize.removeResizeListener(this._depthChartContainer.current, this._resizeHandler);
    try {
      this._depth && this._depth.unload();
    } catch (err) {
      if (__DEV__) bog.warn('Depth chart unmount exception ignored!', err);
    }

  }

  _init() {
    const { theme } = this.props;
    // init depth chart if not yet done
    if (!this._depth) {
      if (__DEV__) bog.info('Init depth chart.');
      this._depth = initDepthChart({
        themeName: theme.depthTheme || DEFAULT_DEPTH_THEME,
        containerEl: this._depthChartContainer.current,
      });
    }
  }

  _depthChartContainer = React.createRef();

  _setDepthChartContainerRef = (ref) => {
    this._depthChartContainer = ref;
  };

  _setChartContainerRef = (ref) => {
    this._chartContainer = ref;
  };
  _userOrdersOndepth(data) {
    if (data && data instanceof Array) {
      const obj = {};
      obj.exch = 'BIJIE';
      obj.orders = [];
      data.forEach((d) => {
        if (d.symbol === this.props.symbol) {
          obj.orders.push({
            id: d.id || d.orderId,
            action: d.side.toLowerCase(),
            amount: d.origQty,
            price: d.price,
            base: d.symbol,
            quote: d.quoteAsset,
            status: 'Open',
          });
        }
      });
      window.UserAccount.ordersAdd(obj);
    }
  }
  render() {
    return (
      <ChartContainer
        ref={this._depthChartContainer}
        hidden={this.props.selectedView !== DEPTH_VIEW_NAME}
        fullScreen={this.props.fullScreen}
        selectedView={this.props.selectedView}
      >

          <Container className="box-inner" />

      </ChartContainer>
    );
  }
}
